const DEFAULT_CONFIG = {
    content: '',
    submitButton: false
};

const WARNING_MODAL_PERMISSIONS_DISCLAIMER_CONFIG = {
    content: 'ui.permissions-warning-disclaimer',
    submitButton: true
};

const WARNING_MODAL_PERMISSIONS_INSTRUCTIONS_CONFIG = {
    content: 'ui.ar-feature-warning',
};

export {
    DEFAULT_CONFIG,
    WARNING_MODAL_PERMISSIONS_DISCLAIMER_CONFIG,
    WARNING_MODAL_PERMISSIONS_INSTRUCTIONS_CONFIG
}